import PropTypes from 'prop-types';

export const Icons = ({ variant, color, className }) => {
  const renderIcon = () => {
    switch (variant) {
      case Icons.HIGHLIGHTS:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
          >
            <g clipPath="url(#clip0_59563_407243)">
              <path
                d="M8 12.5652L4.29161 14.5013L5 10.4005L2 7.49665L6.1458 6.89881L8 3.16797L9.8542 6.89881L14 7.49665L11 10.4005L11.7084 14.5013L8 12.5652Z"
                stroke="white"
                strokeOpacity="0.9"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_59563_407243">
                <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
              </clipPath>
            </defs>
          </svg>
        );
      case Icons.REMOVE:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <rect width="24" height="24" rx="12" fill="#FF576D" />
            <path d="M7 12H17" stroke="white" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      case Icons.MENU:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <g clipPath="url(#clip0_59549_393689)">
              <path
                d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                fill={color || '#AAABAB'}
                stroke={color || '#AAABAB'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                fill={color || '#AAABAB'}
                stroke={color || '#AAABAB'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                fill={color || '#AAABAB'}
                stroke={color || '#AAABAB'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_59549_393689">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      case Icons.EDIT:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M2 14H5.13144L13.3515 5.77998C13.7667 5.36472 14 4.80152 14 4.21426C14 3.627 13.7667 3.0638 13.3515 2.64854C12.9362 2.23329 12.373 2 11.7857 2C11.1985 2 10.6353 2.23329 10.22 2.64854L2 10.8686V14Z"
              stroke={color || '#AAABAB'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.4375 3.43188L12.5689 6.56332"
              stroke={color || '#AAABAB'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.BACK:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.194 18.6943C15.602 18.2867 15.602 17.6259 15.194 17.2184L9.96989 12L15.194 6.78165C15.602 6.37408 15.602 5.71326 15.194 5.30568C14.7859 4.89811 14.1244 4.8981 13.7164 5.30568L7.80602 11.2096C7.58861 11.4267 7.48704 11.7158 7.50132 12.0002C7.48714 12.2844 7.58871 12.5733 7.80604 12.7904L13.7164 18.6943C14.1244 19.1019 14.786 19.1019 15.194 18.6943Z"
              fill={color || '#D6D6D7'}
            />
          </svg>
        );
      case Icons.ACTIVITY:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <g clipPath="url(#clip0_59549_392469)">
              <path
                d="M21.5 12H17.5L14.5 20L10.5 4L7.5 12H3.5"
                stroke="#747475"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_59549_392469">
                <rect width="24" height="24" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
        );
      case Icons.PORTFOLIO:
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.875 9.35938V19.1094H19.375V9.35938"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.373 19.1094V13.8594H14.873V19.1094"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.375 10.1094L12.625 3.35938L16.3732 6.42606L19.3732 8.8806L20.875 10.1094"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.KITS:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <path
              d="M22 21V10.4375C22 9.79103 21.7629 9.17105 21.341 8.71393C20.919 8.25681 20.3467 8 19.75 8H12.25C11.6533 8 11.081 8.25681 10.659 8.71393C10.2371 9.17105 10 9.79103 10 10.4375V15.3125C10 15.959 10.2371 16.579 10.659 17.0361C11.081 17.4932 11.6533 17.75 12.25 17.75H19L22 21Z"
              fill="white"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 16V5.4375C2 4.79103 2.27656 4.17105 2.76884 3.71393C3.26113 3.25681 3.92881 3 4.625 3H13.375C14.0712 3 14.7389 3.25681 15.2312 3.71393C15.7234 4.17105 16 4.79103 16 5.4375V10.3125C16 10.959 15.7234 11.579 15.2312 12.0361C14.7389 12.4932 14.0712 12.75 13.375 12.75H5.5L2 16Z"
              fill="white"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.SEARCHES:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M10.4444 15.8889C13.4513 15.8889 15.8889 13.4513 15.8889 10.4444C15.8889 7.43756 13.4513 5 10.4444 5C7.43756 5 5 7.43756 5 10.4444C5 13.4513 7.43756 15.8889 10.4444 15.8889Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.9987 19L14.332 14.3333"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.TRANSACTIONS:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <path
              d="M6.66406 7.83464H18.3307M18.3307 7.83464L15.4141 4.91797M18.3307 7.83464L15.4141 10.7513"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.332 16.1667H6.66536M6.66536 16.1667L9.58203 13.25M6.66536 16.1667L9.58203 19.0833"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.PROJECTS:
        return (
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.26611 4.16669H6.38648C5.95674 4.16669 5.54459 4.3374 5.2407 4.64128C4.93683 4.94516 4.76611 5.3573 4.76611 5.78705V15.0463C4.76611 15.4761 4.93683 15.8882 5.2407 16.1921C5.54459 16.496 5.95674 16.6667 6.38648 16.6667L14.8124 16.6665C15.2422 16.6665 15.6543 16.4958 15.9582 16.1919C16.262 15.888 16.4328 15.4759 16.4328 15.0462V5.78687C16.4328 5.35713 16.262 4.94498 15.9582 4.6411C15.6543 4.33722 15.2422 4.1665 14.8124 4.1665H13.9328"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.8498 2.5H9.34977C8.4293 2.5 7.68311 3.24619 7.68311 4.16667C7.68311 5.08714 8.4293 5.83333 9.34977 5.83333H11.8498C12.7703 5.83333 13.5164 5.08714 13.5164 4.16667C13.5164 3.24619 12.7703 2.5 11.8498 2.5Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.51611 9.1665H12.6828"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.51611 12.5H12.6828"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.FILES:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M13.2857 18H4.71429C4.25963 18 3.82359 17.8127 3.5021 17.4793C3.18061 17.1459 3 16.6937 3 16.2222V3.77778C3 3.30628 3.18061 2.8541 3.5021 2.5207C3.82359 2.1873 4.25963 2 4.71429 2H10L15 7V16.2222C15 16.6937 14.8194 17.1459 14.4979 17.4793C14.1764 17.8127 13.7404 18 13.2857 18Z"
              fill="white"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.2857 21H9.71429C9.25963 21 8.82359 20.8127 8.5021 20.4793C8.18061 20.1459 8 19.6937 8 19.2222V6.77778C8 6.30628 8.18061 5.8541 8.5021 5.5207C8.82359 5.1873 9.25963 5 9.71429 5H15L20 10V19.2222C20 19.6937 19.8194 20.1459 19.4979 20.4793C19.1764 20.8127 18.7404 21 18.2857 21Z"
              fill="white"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15 5V9C15 9.26522 15.1054 9.51957 15.2929 9.70711C15.4804 9.89464 15.7348 10 16 10H20"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.NOTES:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
          >
            <g clipPath="url(#clip0_59549_393620)">
              <path
                d="M7.9987 5.83313H5.4987C5.05667 5.83313 4.63275 6.00872 4.32019 6.32129C4.00763 6.63385 3.83203 7.05777 3.83203 7.4998V14.9998C3.83203 15.4418 4.00763 15.8657 4.32019 16.1783C4.63275 16.4909 5.05667 16.6665 5.4987 16.6665H12.9987C13.4407 16.6665 13.8646 16.4909 14.1772 16.1783C14.4898 15.8657 14.6654 15.4418 14.6654 14.9998V12.4998"
                stroke="#D0D1D4"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8 12.5003H10.5L17.5833 5.41694C17.9149 5.08542 18.1011 4.63578 18.1011 4.16694C18.1011 3.6981 17.9149 3.24846 17.5833 2.91694C17.2518 2.58542 16.8022 2.39917 16.3333 2.39917C15.8645 2.39917 15.4149 2.58542 15.0833 2.91694L8 10.0003V12.5003Z"
                stroke="#D0D1D4"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.832 4.16687L16.332 6.66687"
                stroke="#D0D1D4"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_59549_393620">
                <rect width="20" height="20" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
        );
      case Icons.MESSAGE:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
          >
            <path
              d="M4.81988 13.3818L5.73995 13.7735L5.93781 13.3088L5.68124 12.8738L4.81988 13.3818ZM3.52963 16.4121L4.4497 16.8038H4.4497L3.52963 16.4121ZM4.16963 17.0744L3.8097 16.1415H3.8097L4.16963 17.0744ZM7.35708 15.8448L7.83917 14.9687L7.4314 14.7443L6.99715 14.9118L7.35708 15.8448ZM16.2331 10C16.2331 13.1297 13.696 15.6667 10.5664 15.6667V17.6667C14.8006 17.6667 18.2331 14.2342 18.2331 10H16.2331ZM10.5664 4.33337C13.696 4.33337 16.2331 6.87043 16.2331 10H18.2331C18.2331 5.76586 14.8006 2.33337 10.5664 2.33337V4.33337ZM4.89973 10C4.89973 6.87043 7.43678 4.33337 10.5664 4.33337V2.33337C6.33221 2.33337 2.89973 5.76586 2.89973 10H4.89973ZM5.68124 12.8738C5.18481 12.032 4.89973 11.0508 4.89973 10H2.89973C2.89973 11.4179 3.28554 12.7486 3.95851 13.8898L5.68124 12.8738ZM4.4497 16.8038L5.73995 13.7735L3.8998 12.99L2.60956 16.0203L4.4497 16.8038ZM3.8097 16.1415C4.22201 15.9824 4.62282 16.3972 4.4497 16.8038L2.60956 16.0203C2.09019 17.2401 3.29263 18.4846 4.52955 18.0074L3.8097 16.1415ZM6.99715 14.9118L3.8097 16.1415L4.52955 18.0074L7.717 16.7778L6.99715 14.9118ZM10.5664 15.6667C9.57575 15.6667 8.64727 15.4134 7.83917 14.9687L6.87498 16.7209C7.97097 17.324 9.23016 17.6667 10.5664 17.6667V15.6667Z"
              fill="white"
              fillOpacity="0.8"
            />
          </svg>
        );
      case Icons.RECENT_ACTIVITY:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M6.16602 7.83464H17.8327M17.8327 7.83464L14.916 4.91797M17.8327 7.83464L14.916 10.7513"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.832 16.1667H6.16536M6.16536 16.1667L9.08203 13.25M6.16536 16.1667L9.08203 19.0833"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.DOCUMENT_TO_SIGN:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M13.2857 18H4.71429C4.25963 18 3.82359 17.8127 3.5021 17.4793C3.18061 17.1459 3 16.6937 3 16.2222V3.77778C3 3.30628 3.18061 2.8541 3.5021 2.5207C3.82359 2.1873 4.25963 2 4.71429 2H10L15 7V16.2222C15 16.6937 14.8194 17.1459 14.4979 17.4793C14.1764 17.8127 13.7404 18 13.2857 18Z"
              fill="white"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.2857 21H9.71429C9.25963 21 8.82359 20.8127 8.5021 20.4793C8.18061 20.1459 8 19.6937 8 19.2222V6.77778C8 6.30628 8.18061 5.8541 8.5021 5.5207C8.82359 5.1873 9.25963 5 9.71429 5H15L20 10V19.2222C20 19.6937 19.8194 20.1459 19.4979 20.4793C19.1764 20.8127 18.7404 21 18.2857 21Z"
              fill="white"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15 5V9C15 9.26522 15.1054 9.51957 15.2929 9.70711C15.4804 9.89464 15.7348 10 16 10H20"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.ACTIVE_SEARCHES:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M10.4444 15.8889C13.4513 15.8889 15.8889 13.4513 15.8889 10.4444C15.8889 7.43756 13.4513 5 10.4444 5C7.43756 5 5 7.43756 5 10.4444C5 13.4513 7.43756 15.8889 10.4444 15.8889Z"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19.0007 19L14.334 14.3334"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.OVERDUE_TASK:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M3.5 5.5L5 7L7.5 4.5"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.5 11.5L5 13L7.5 10.5"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.5 17.5L5 19L7.5 16.5"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11 6H20"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11 12H20"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11 18H20"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.UPCOMMING_MILESTONES:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <g clipPath="url(#clip0_59563_406464)">
              <path
                d="M11 6H20"
                stroke="#aaabab"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11 12H20"
                stroke="#aaabab"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11 18H20"
                stroke="#aaabab"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="5.5" cy="6" r="1.5" stroke="#aaabab" strokeWidth="2" />
              <circle cx="5.5" cy="12" r="1.5" stroke="#aaabab" strokeWidth="2" />
              <circle cx="5.5" cy="18" r="1.5" stroke="#aaabab" strokeWidth="2" />
            </g>
            <defs>
              <clipPath id="clip0_59563_406464">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      case Icons.NEW_COMMENTS:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5.18229 16.0581L6.10236 16.4498L6.30022 15.9851L6.04365 15.5501L5.18229 16.0581ZM3.54135 19.912L2.62128 19.5203H2.62128L3.54135 19.912ZM4.18134 20.5744L4.54126 21.5074H4.54126L4.18134 20.5744ZM8.22693 19.0137L8.70902 18.1376L8.30125 17.9132L7.86701 18.0807L8.22693 19.0137ZM19.0781 12C19.0781 15.866 15.9441 19 12.0781 19V21C17.0487 21 21.0781 16.9706 21.0781 12H19.0781ZM12.0781 5C15.9441 5 19.0781 8.13401 19.0781 12H21.0781C21.0781 7.02944 17.0487 3 12.0781 3V5ZM5.07811 12C5.07811 8.13401 8.21212 5 12.0781 5V3C7.10755 3 3.07811 7.02944 3.07811 12H5.07811ZM6.04365 15.5501C5.43029 14.51 5.07811 13.2977 5.07811 12H3.07811C3.07811 13.6647 3.53101 15.2267 4.32093 16.5661L6.04365 15.5501ZM4.46142 20.3038L6.10236 16.4498L4.26222 15.6663L2.62128 19.5203L4.46142 20.3038ZM3.82142 19.6414C4.23373 19.4824 4.63454 19.8972 4.46142 20.3038L2.62128 19.5203C2.10191 20.7401 3.30435 21.9846 4.54126 21.5074L3.82142 19.6414ZM7.86701 18.0807L3.82142 19.6414L4.54126 21.5074L8.58685 19.9467L7.86701 18.0807ZM12.0781 19C10.8548 19 9.70754 18.687 8.70902 18.1376L7.74483 19.8898C9.03123 20.5977 10.5092 21 12.0781 21V19Z"
              fill="#aaabab"
            />
          </svg>
        );
      case Icons.NEW_FAVOURITES:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M4.37884 13.2743C3.52487 12.3958 3 11.2029 3 9.88889C3 7.18883 5.21619 5 7.95 5C9.62414 5 11.1042 5.82084 12 7.07726C12.8958 5.82084 14.3759 5 16.05 5C18.7838 5 21 7.18883 21 9.88889C21 11.2674 20.4224 12.5126 19.4931 13.4013L13.4238 19.5561C12.6407 20.3503 11.3592 20.3504 10.5759 19.5564L4.37884 13.2743Z"
              stroke="#aaabab"
              strokeWidth="2"
            />
          </svg>
        );
      case Icons.TOUR_REQUESTS:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M17.4008 4.80005H6.60078C5.60667 4.80005 4.80078 5.60594 4.80078 6.60005V17.4001C4.80078 18.3942 5.60667 19.2001 6.60078 19.2001H17.4008C18.3949 19.2001 19.2008 18.3942 19.2008 17.4001V6.60005C19.2008 5.60594 18.3949 4.80005 17.4008 4.80005Z"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.5996 3.59998V5.99998"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.40039 3.59998V5.99998"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.80078 9.59998H19.2008"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.1992 14.4L13.7992 14.4"
              stroke="#aaabab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.ADDRESS:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
          >
            <path
              d="M22.4 10.4C22.4 9.07452 23.4745 8 24.8 8H52C53.3255 8 54.4 9.07452 54.4 10.4V57.3037C54.4 58.351 53.551 59.2 52.5037 59.2H24.8C23.4745 59.2 22.4 58.1255 22.4 56.8V10.4Z"
              fill="#4673D1"
            />
            <path
              d="M8 26.4C8 25.0745 9.07452 24 10.4 24H31.2C32.5255 24 33.6 25.0745 33.6 26.4V59.2H10.4C9.07452 59.2 8 58.1255 8 56.8V26.4Z"
              fill="#51BFE1"
            />
            <path
              d="M22.4 24H31.2C32.5255 24 33.6 25.0745 33.6 26.4V59.2H24.8C23.4745 59.2 22.4 58.1255 22.4 56.8V24Z"
              fill="#34569D"
            />
          </svg>
        );
      case Icons.COPY:
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 1H7.5C6.67157 1 6 1.67157 6 2.5V9.5C6 10.3284 6.67157 11 7.5 11H12.5C13.3284 11 14 10.3284 14 9.5V2.5C14 1.67157 13.3284 1 12.5 1Z"
              stroke={color || '#B2B4B8'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 5H3.5C2.67157 5 2 5.67157 2 6.5V13.5C2 14.3284 2.67157 15 3.5 15H8.5C9.32843 15 10 14.3284 10 13.5V11"
              stroke={color || '#B2B4B8'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.CLIENTS:
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.375 7.5C14.375 9.98528 12.3603 12 9.875 12C7.38972 12 5.375 9.98528 5.375 7.5C5.375 5.01472 7.38972 3 9.875 3C12.3603 3 14.375 5.01472 14.375 7.5Z"
              stroke="#747475"
              strokeWidth="2"
            />
            <path
              d="M16.625 3.0625C18.7533 3.41956 20.375 5.27053 20.375 7.50028C20.375 9.73003 18.7533 11.581 16.625 11.9381"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M3.125 20.625C3.54568 18.2211 5.4798 16.125 7.62486 16.125H12.125C14.2701 16.125 16.2043 18.2211 16.625 20.625"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.125 16.125C20.2701 16.125 22.2043 18.2211 22.625 20.625"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.NOTIFICATIONS:
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.25 18C10.25 19.2426 11.2574 20.25 12.5 20.25C13.7426 20.25 14.75 19.2426 14.75 18"
              stroke="#747475"
              strokeWidth="2"
            />
            <path
              d="M11 5.46742L11.2853 6.42587C11.7093 6.29967 12 5.90984 12 5.46742H11ZM7.25005 10.5H6.25005V10.5L7.25005 10.5ZM7.25013 13.5L8.25013 13.5001L8.25013 13.5L7.25013 13.5ZM14 5.4674H13C13 5.90982 13.2907 6.29965 13.7148 6.42585L14 5.4674ZM12 5.25C12 4.97386 12.2239 4.75 12.5 4.75V2.75C11.1193 2.75 10 3.86929 10 5.25H12ZM12 5.46742V5.25H10V5.46742H12ZM8.25005 10.5C8.25005 8.57623 9.52903 6.94857 11.2853 6.42587L10.7147 4.50897C8.13379 5.27713 6.25005 7.66727 6.25005 10.5H8.25005ZM8.25013 13.5L8.25005 10.5L6.25005 10.5L6.25013 13.5L8.25013 13.5ZM6.50005 16C6.74619 16 7.04373 15.9597 7.33338 15.8017C7.63671 15.6362 7.8455 15.3888 7.98036 15.1191C8.21386 14.6522 8.25007 14.0593 8.25013 13.5001L6.25013 13.4999C6.2501 13.7582 6.23901 13.9429 6.22115 14.0738C6.20261 14.2096 6.18243 14.2428 6.19154 14.2246C6.2092 14.1893 6.26564 14.1059 6.37563 14.0459C6.47193 13.9934 6.53513 14 6.50005 14V16ZM6.87503 17C6.5493 17 6.43428 16.9001 6.39341 16.8555C6.33634 16.7933 6.28125 16.676 6.28125 16.5C6.28125 16.3197 6.34068 16.1603 6.40937 16.0688C6.46715 15.9917 6.49486 16 6.50005 16V14C5.75521 14 5.17351 14.3833 4.8094 14.8687C4.4562 15.3397 4.28125 15.9303 4.28125 16.5C4.28125 17.074 4.46054 17.7067 4.91911 18.207C5.39388 18.7249 6.07574 19 6.87503 19V17ZM18.125 17H6.87503V19H18.125V17ZM18.5 16C18.5052 16 18.5328 15.9917 18.5906 16.0687C18.6593 16.1603 18.7188 16.3197 18.7188 16.5C18.7188 16.676 18.6637 16.7933 18.6066 16.8555C18.5657 16.9001 18.4507 17 18.125 17V19C18.9243 19 19.6061 18.7249 20.0809 18.207C20.5395 17.7067 20.7188 17.074 20.7188 16.5C20.7188 15.9303 20.5438 15.3397 20.1906 14.8688C19.8265 14.3833 19.2449 14 18.5 14V16ZM16.75 13.5C16.75 14.0591 16.7862 14.6521 17.0196 15.1191C17.1545 15.3888 17.3633 15.6362 17.6667 15.8017C17.9563 15.9597 18.2539 16 18.5 16V14C18.4649 14 18.5281 13.9934 18.6244 14.0459C18.7344 14.1059 18.7909 14.1894 18.8085 14.2247C18.8177 14.2429 18.7975 14.2097 18.779 14.0739C18.7611 13.943 18.75 13.7584 18.75 13.5H16.75ZM16.75 10.5V13.5H18.75V10.5H16.75ZM13.7148 6.42585C15.471 6.94853 16.75 8.5762 16.75 10.5H18.75C18.75 7.66723 16.8663 5.27706 14.2852 4.50894L13.7148 6.42585ZM13 5.25V5.4674H15V5.25H13ZM12.5 4.75C12.7761 4.75 13 4.97386 13 5.25H15C15 3.86929 13.8807 2.75 12.5 2.75V4.75Z"
              fill="#747475"
            />
          </svg>
        );
      case Icons.ADD_CLIENT:
        return (
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.6667 6.66634C11.6667 8.50729 10.1743 9.99967 8.33333 9.99967C6.49238 9.99967 5 8.50729 5 6.66634C5 4.82539 6.49238 3.33301 8.33333 3.33301C10.1743 3.33301 11.6667 4.82539 11.6667 6.66634Z"
              stroke={color || '#262626'}
              strokeWidth="2"
            />
            <path
              d="M16.6665 7.5V12.5"
              stroke={color || '#262626'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.1665 10L19.1665 10"
              stroke={color || '#262626'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.3335 16.2497C3.64511 14.6916 5.07779 13.333 6.66673 13.333H10.0002C11.5891 13.333 13.0219 14.6916 13.3335 16.2497"
              stroke={color || '#262626'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.MULTISELECT:
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.5 10.0003L9.58333 12.0837L16.25 5.41699"
              stroke={color || '#262626'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.0833 3.75H5.83333C4.68274 3.75 3.75 4.68274 3.75 5.83333V14.1667C3.75 15.3173 4.68274 16.25 5.83333 16.25H14.1667C15.3173 16.25 16.25 15.3173 16.25 14.1667V10"
              stroke={color || '#262626'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.DROPDOWN:
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.5 6L8 10.5L12.5 6"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.ADD:
        return (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M3.5 8H13.5" stroke="white" strokeWidth="2" strokeLinecap="round" />
            <path d="M8.5 13L8.5 3" stroke="white" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      case Icons.PROFILE:
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.3332 6.66732C13.3332 8.50827 11.8408 10.0007 9.99984 10.0007C8.15889 10.0007 6.6665 8.50827 6.6665 6.66732C6.6665 4.82637 8.15889 3.33398 9.99984 3.33398C11.8408 3.33398 13.3332 4.82637 13.3332 6.66732Z"
              stroke="#FF576D"
              strokeWidth="2"
            />
            <path
              d="M5 16.2507C5.31162 14.6926 6.74429 13.334 8.33323 13.334H11.6667C13.2556 13.334 14.6884 14.6926 15 16.2507"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.HAMBURGER:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            id="vendorDraftMenuIcon"
          >
            <circle cx="5" cy="12" r="2" />
            <circle cx="12" cy="12" r="2" />
            <circle cx="19" cy="12" r="2" />
          </svg>
        );
      case Icons.REASSIGN:
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.54297 9.16575C2.72971 7.33246 3.58486 5.63209 4.94525 4.38905C6.30564 3.14601 8.07605 2.44732 9.9187 2.42627C11.7614 2.40522 13.5473 3.0633 14.9357 4.27494C16.3241 5.48659 17.2179 7.16698 17.4464 8.99552C17.675 10.8241 17.2224 12.6728 16.1749 14.1889C15.1275 15.705 13.5585 16.7824 11.7674 17.2156C9.97623 17.6488 8.08831 17.4074 6.4638 16.5375C4.83929 15.6675 3.5919 14.23 2.95964 12.4991M2.54297 16.6658V12.4991H6.70964"
              stroke={color || '#FF576D'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.SHARE:
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.8333 3.39886V6.66602C5.78938 6.66602 2.91322 9.55641 2.54129 15.0008C2.51477 15.389 3.01595 15.5618 3.27148 15.2683C5.20298 13.05 7.5345 12.0827 10.8333 12.0827V15.7665C10.8333 15.9447 11.0488 16.0339 11.1748 15.9079L17.2172 9.86552C17.3734 9.70932 17.3734 9.45605 17.2172 9.29984L11.1748 3.25744C11.0488 3.13144 10.8333 3.22068 10.8333 3.39886Z"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.ARCHIVE:
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.54415 4.70153L2.55132 10.68C2.51733 10.782 2.5 10.8888 2.5 10.9963V14.6673C2.5 15.7719 3.39543 16.6673 4.5 16.6673H15.5C16.6046 16.6673 17.5 15.7719 17.5 14.6673V10.9963C17.5 10.8888 17.4827 10.782 17.4487 10.68L15.4558 4.70153C15.1836 3.88484 14.4193 3.33398 13.5585 3.33398H6.44152C5.58066 3.33398 4.81638 3.88484 4.54415 4.70153Z"
              stroke={color || '#262626'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.16699 8.33398H7.08366V8.75065C7.08366 10.3615 8.3895 11.6673 10.0003 11.6673V11.6673C11.6112 11.6673 12.917 10.3615 12.917 8.75065V8.33398H15.8337"
              stroke={color || '#262626'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.CHECK:
        return (
          <svg
            width="14"
            height="10"
            viewBox="0 0 14 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 5L5 9L13 1"
              stroke="#04A451"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.FILTER:
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.2256 4.99527C2.94272 4.67198 3.1723 4.16602 3.60188 4.16602H16.3981C16.8277 4.16602 17.0573 4.67198 16.7744 4.99527L11.6667 10.8327V15.5237C11.6667 15.7131 11.5597 15.8862 11.3903 15.9709L9.05694 17.1375C8.72449 17.3038 8.33333 17.062 8.33333 16.6903V10.8327L3.2256 4.99527Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.CLOSE:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_66865_508288)">
              <path
                d="M18 6L6 18"
                stroke={color || '#676767'}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke={color || '#676767'}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_66865_508288">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      case Icons.TASK:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 5.00022H6.94444C6.42875 5.00022 5.93417 5.20508 5.56951 5.56973C5.20486 5.93439 5 6.42896 5 6.94466V18.0558C5 18.5715 5.20486 19.066 5.56951 19.4307C5.93417 19.7954 6.42875 20.0002 6.94444 20.0002L17.0556 20C17.5713 20 18.0658 19.7951 18.4305 19.4305C18.7951 19.0658 19 18.5713 19 18.0556V6.94444C19 6.42875 18.7951 5.93417 18.4305 5.56951C18.0658 5.20486 17.5713 5 17.0556 5H16"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.5 3H10.5C9.39543 3 8.5 3.89543 8.5 5C8.5 6.10457 9.39543 7 10.5 7H13.5C14.6046 7 15.5 6.10457 15.5 5C15.5 3.89543 14.6046 3 13.5 3Z"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.5 11H14.5"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.5 15H14.5"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.ASSIGNEES:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 8C12.5 10.2091 10.7091 12 8.5 12C6.29086 12 4.5 10.2091 4.5 8C4.5 5.79086 6.29086 4 8.5 4C10.7091 4 12.5 5.79086 12.5 8Z"
              stroke="#747475"
              strokeWidth="2"
            />
            <path
              d="M15.5 12C17.7091 12 19.5 10.2091 19.5 8C19.5 5.79086 17.7091 4 15.5 4"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M2.5 19.5C2.87394 17.6303 4.59315 16 6.49988 16H10.5C12.4067 16 14.1261 17.6303 14.5 19.5"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.5 16C19.4067 16 21.1261 17.6303 21.5 19.5"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.PHONE:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.18229 16.0581L6.10236 16.4498L6.30022 15.9851L6.04365 15.5501L5.18229 16.0581ZM3.54135 19.912L2.62128 19.5203H2.62128L3.54135 19.912ZM4.18134 20.5744L4.54126 21.5074H4.54126L4.18134 20.5744ZM8.22693 19.0137L8.70902 18.1376L8.30125 17.9132L7.86701 18.0807L8.22693 19.0137ZM19.0781 12C19.0781 15.866 15.9441 19 12.0781 19V21C17.0487 21 21.0781 16.9706 21.0781 12H19.0781ZM12.0781 5C15.9441 5 19.0781 8.13401 19.0781 12H21.0781C21.0781 7.02944 17.0487 3 12.0781 3V5ZM5.07811 12C5.07811 8.13401 8.21212 5 12.0781 5V3C7.10755 3 3.07811 7.02944 3.07811 12H5.07811ZM6.04365 15.5501C5.43029 14.51 5.07811 13.2977 5.07811 12H3.07811C3.07811 13.6647 3.53101 15.2267 4.32093 16.5661L6.04365 15.5501ZM4.46142 20.3038L6.10236 16.4498L4.26222 15.6663L2.62128 19.5203L4.46142 20.3038ZM3.82142 19.6414C4.23373 19.4824 4.63454 19.8972 4.46142 20.3038L2.62128 19.5203C2.10191 20.7401 3.30435 21.9846 4.54126 21.5074L3.82142 19.6414ZM7.86701 18.0807L3.82142 19.6414L4.54126 21.5074L8.58685 19.9467L7.86701 18.0807ZM12.0781 19C10.8548 19 9.70754 18.687 8.70902 18.1376L7.74483 19.8898C9.03123 20.5977 10.5092 21 12.0781 21V19Z"
              fill="#4673D1"
            />
          </svg>
        );
      case Icons.EMAIL:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="4"
              y="6"
              width="16"
              height="12"
              rx="2"
              stroke="#FB913A"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M4 7L11.4 12.55C11.7556 12.8167 12.2444 12.8167 12.6 12.55L20 7"
              stroke="#FB913A"
              strokeWidth="2"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icons.INFO:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_76608_504207)">
              <path
                d="M12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5Z"
                stroke="#4673D1"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 12C12 13.5621 12 14.1879 12 15.75"
                stroke="#4673D1"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="12" cy="7.5" r="1.5" fill="#4673D1" />
            </g>
            <defs>
              <clipPath id="clip0_76608_504207">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      default:
        return null;
    }
  };
  return <>{renderIcon()}</>;
};

Icons.BACK = 'Back';
Icons.NOTES = 'Notes';
Icons.MESSAGE = 'Message';
Icons.ACTIVITY = 'Activity';
Icons.PORTFOLIO = 'Portfolio';
Icons.KITS = 'Kits';
Icons.SEARCHES = 'Searches';
Icons.TRANSACTIONS = 'Transactions';
Icons.PROJECTS = 'Projects';
Icons.FILES = 'Files';
Icons.EDIT = 'Edit';
Icons.MENU = 'Menu';
Icons.REMOVE = 'Remove';
Icons.HIGHLIGHTS = 'Highlights';
Icons.RECENT_ACTIVITY = 'recentActivity';
Icons.DOCUMENT_TO_SIGN = 'documentToSign';
Icons.ACTIVE_SEARCHES = 'activeSearches';
Icons.OVERDUE_TASK = 'overdueTask';
Icons.UPCOMMING_MILESTONES = 'upcommingMilestones';
Icons.NEW_COMMENTS = 'newComments';
Icons.NEW_FAVOURITES = 'newFavourites';
Icons.TOUR_REQUESTS = 'tourRequest';
Icons.ADDRESS = 'address';
Icons.COPY = 'copy';
Icons.CLIENTS = 'clients';
Icons.NOTIFICATIONS = 'notifications';
Icons.ADD_CLIENT = 'addClient';
Icons.MULTISELECT = 'multiSelect';
Icons.DROPDOWN = 'dropdown';
Icons.ADD = 'add';
Icons.PROFILE = 'Profile';
Icons.HAMBURGER = 'Hamburger';
Icons.REASSIGN = 'Reassign';
Icons.SHARE = 'Share';
Icons.ARCHIVE = 'Archive';
Icons.CHECK = 'Check';
Icons.FILTER = 'Filter';
Icons.CLOSE = 'Close';
Icons.TASK = 'Task';
Icons.ASSIGNEES = 'Assignees';
Icons.PHONE = 'Phone';
Icons.EMAIL = 'Email';
Icons.INFO = 'Info';

Icons.propTypes = {
  variant: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
};

Icons.defaultProps = {
  variant: '',
  color: '',
  className: '',
};
